import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import axiosInstance from 'api/axios';
import {
  type EnergyAuditResponse,
  type QuickWinsReponse,
} from 'interfaces/EnergyAudit.interface';

export const useFetchEnergyAudit = (
  id?: string
): UseQueryResult<EnergyAuditResponse> => {
  return useQuery<EnergyAuditResponse>({
    queryKey: ['fetchEnergyAudit', id],
    queryFn: async () => {
      if (!id) {
        return null;
      }
      const response = await axiosInstance.get(`asset/energy_audit`, {
        params: { connection_point_id_client: id },
      });
      return response.data;
    },
  });
};

export const useListEnergyAudit = (
  id?: string
): UseQueryResult<QuickWinsReponse> => {
  return useQuery<QuickWinsReponse>({
    queryKey: ['listQuickWins'],
    queryFn: async () => {
      // if (!id) {
      //   return null;
      // }
      const response = await axiosInstance.get(`asset/energy_audit/list`, {
        params: { building_id: id },
      });
      return response.data;
    },
  });
};
